export default __webpack_public_path__ + "static/blog2-c3809a2eb6a0baf6b5cb321ed76c29f2.jpg";